import * as React from "react";
import { computed, action } from "mobx"
import { observer, inject } from "mobx-react";
import { PrivilegeMembershipEdit } from "./CollectionPrivilegesEdit.Membership";
import { CollectionStoreImpl } from "../Stores/CollectionStore";
import * as DocumentManagement from "../DocumentManagement";

interface ICollectionPrivilegeInfoProps {
	groupId: string;
	collection: DocumentManagement.CollectionDetails;
	item: DocumentManagement.PrivilegesForGroup;
	store?: CollectionStoreImpl;
}


@inject('store')
@observer
export class CollectionPrivilegeInfoEdit extends React.Component<ICollectionPrivilegeInfoProps, {}> {

	@computed get isSelected(): boolean {
		return this.props.store.selectedPrivileges.some(p => p.groupId === this.props.item.groupId);
	}

	@action handleClickItem = (e: React.MouseEvent<any>) => {
		if (this.props.store.privilegeSelectionMode) {
			if (!this.props.store.selectedPrivileges.remove(this.props.item)) {
				this.props.store.selectedPrivileges.push(this.props.item);
			}
			e.preventDefault();
		}
	}

	render() {
		return <tr data-test-name='privilegeGroup' data-test-id={this.props.item.groupName}>
			<td className="check-cell" data-test-name='privilegeSelect'>
				<span className="list-simple__selection" onClick={this.handleClickItem.bind(this)}>
					<label className="custom-radiocheck">
						<input type="checkbox" checked={this.isSelected} />
						<span className="checkbox-style"></span>
					</label>
				</span>
			</td>
			<td>{this.props.item.groupName}</td>
			{this.props.item.privilegeMemberships.map(privileg => {
				return <PrivilegeMembershipEdit key={this.props.groupId + privileg.name} collection={this.props.collection} groupId={this.props.groupId} item={privileg} />;
			})}
		</tr>
	}
}